export const BOOTSTRAP = Symbol('bootstrap');
export const BOOTSTRAP_PROMISE = Symbol('bootstrapPromise');
export const CHILDREN_WIDGET = Symbol('childrenWidget');
export const LIFECYCLE_CALLBACK = Symbol('lifecycleCallback');
export const LOAD_PROMISE = Symbol('loadPromise');
export const MOUNT = Symbol('mount');
export const MOUNT_PROMISE = Symbol('mountPromise');
export const NAME = Symbol('name');
export const PORTAL_DESTINATIONS = Symbol('portalDestinations');
export const PORTALS = Symbol('portals');
export const PREFETCH = Symbol('prefetch');
export const SET_STATE = Symbol('setState');
export const TIMEOUTS = Symbol('timeouts');
export const UNLOAD = Symbol('unload');
export const UNLOAD_PROMISE = Symbol('unloadPromise');
export const UNMOUNT = Symbol('unmount');
export const UNMOUNT_PROMISE = Symbol('unmountPromise');
export const UPDATE = Symbol('update');
